const lettersFeedback = document.createElement('script');
// the inner text is the code relative to the popup configuration
// it is built on the involve platform and received via task card
lettersFeedback.innerText = `involvemeEmbedPopup.
createTriggerEvent({
  projectUrl: "autosservico-pesquisa-cartas",
  organizationUrl: "https://letrus-estudante.involve.me",
  embedMode: "popup",
  triggerEvent: "exit",
  popupSize: "medium",
})`;

export {lettersFeedback};
